import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select'

// helpers
import { showMessage } from "../../../helpers/message.js";

// api
import indiceiqg_api from "../../../api/indiceiqg_api.js";
import usuario_api from "../../../api/usuario_api.js";

export default function IndiceIQGFicha({ item, tipo, handleReturn }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);
    const [isDisable, set_isDisable] = useState(true);

    // Tipo de Índice
    const options_tipoIndice = [{ label: "Índice Principal", value: "Principal" }, { label: "Índice Sintético", value: "Sintético" }, { label: "Índice Analítico", value: "Analítico" }];
    const [tipoIndice, set_tipoIndice] = useState(null);
    const handleChangeTipoIndice = (value) => {
        set_tipoIndice(value);
        clearErrors("tipoIndice")
        setValue("tipoIndice", value, true);

        if (value == "Sintético" || value == "Analítico")
            loadOptionsIndicePrincipal();
    }

    // Índice Principal
    const [options_indicePrincipal, set_options_indicePrincipal] = useState([]);
    const loadOptionsIndicePrincipal = () => {
        setshowLoading(true);
        indiceiqg_api.getListaIndiceIQG().then(result => {
            setshowLoading(false);
            if (result.status !== 200)
                showMessage("Aviso", result.message, 'error', null);
            else
                set_options_indicePrincipal(result.data);
        })
    }
    const [indicePrincipal, set_indicePrincipal] = useState(null);
    const handleChangeIndicePrincipal = (value) => {
        set_indicePrincipal(value);
        clearErrors("indicePrincipal")
        setValue("indicePrincipal", value, true);

        if (tipoIndice == "Analítico")
            loadOptionsIndiceSintetico(value.indiceIQG_Id);
    }

    // Índice Sintético
    const [options_indiceSintetico, set_options_indiceSintetico] = useState([]);
    const [indiceSintetico, set_indiceSintetico] = useState(null);
    const loadOptionsIndiceSintetico = (indiceIQG_Id) => {
        setshowLoading(true);
        indiceiqg_api.getListaIndiceSinteticoIQGByIndicePrincipal(indiceIQG_Id).then(result => {
            setshowLoading(false);
            if (result.status !== 200)
                showMessage("Aviso", result.message, 'error', null);
            else
                set_options_indiceSintetico(result.data);
        })
    }
    const handleChangeIndiceSintetico = (value) => {
        set_indiceSintetico(value);
        clearErrors("indiceSintetico")
        setValue("indiceSintetico", value, true);
    }

    const Voltar = () => {
        handleReturn();
    }

    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("CadastroIndiceIQG", "Editar").then((result) => { set_isDisable(!result); });

        loadForm();
    }, []);

    const loadForm = () => {
        set_tipoIndice(tipo);
        if (item) {
            if (tipo == "Sintético") {
                loadOptionsIndicePrincipal();
                set_indicePrincipal(item.indiceIQG);
                clearErrors("indicePrincipal")
                setValue("indicePrincipal", item.indiceIQG, true);
            }
            else if (tipo == "Analítico") {
                loadOptionsIndicePrincipal();
                set_indicePrincipal(item.indiceSinteticoIQG.indiceIQG);
                clearErrors("indicePrincipal")
                setValue("indicePrincipal", item.indiceSinteticoIQG.indiceIQG, true);

                loadOptionsIndiceSintetico(item.indiceSinteticoIQG.indiceIQG_Id);
                set_indiceSintetico(item.indiceSinteticoIQG);
                clearErrors("indiceSintetico")
                setValue("indiceSintetico", item.indiceSinteticoIQG, true);
            }


            setValue("identificacao", item.identificacao);
            setValue("fatorPeso", item.fator);
        }
    }

    const onSubmit = (data) => {
        switch (tipoIndice) {
            case "Principal": submitIndiceIQG(data); break;
            case "Sintético": submitIndiceSinteticoIQG(data); break;
            case "Analítico": submitIndiceAnaliticoIQG(data); break;
        }
    }

    const submitIndiceIQG = (data) => {
        let json_submit = {
            indiceIQG_Id: item != null ? item.indiceIQG_Id : 0,
            identificacao: data.identificacao,
            fator: data.fatorPeso
        };

        setshowLoading(true);
        if (json_submit.indiceIQG_Id == 0)
            indiceiqg_api.postIndiceIQG(json_submit).then(result => handleReturnSubmit(result));
        else
            indiceiqg_api.putIndiceIQG(json_submit).then(result => handleReturnSubmit(result));
    }

    const submitIndiceSinteticoIQG = (data) => {
        let json_submit = {
            indiceIQG_Id: indicePrincipal.indiceIQG_Id,
            indiceSinteticoIQG_Id: item != null ? item.indiceSinteticoIQG_Id : 0,
            identificacao: data.identificacao,
            fator: data.fatorPeso
        };

        setshowLoading(true);
        if (json_submit.indiceSinteticoIQG_Id == 0)
            indiceiqg_api.postIndiceSinteticoIQG(json_submit).then(result => handleReturnSubmit(result));
        else
            indiceiqg_api.putIndiceSinteticoIQG(json_submit).then(result => handleReturnSubmit(result));
    }

    const submitIndiceAnaliticoIQG = (data) => {
        let json_submit = {
            indiceSinteticoIQG_Id: indiceSintetico.indiceSinteticoIQG_Id,
            indiceAnaliticoIQG_Id: item != null ? item.indiceAnaliticoIQG_Id : 0,
            identificacao: data.identificacao,
            fator: data.fatorPeso
        };

        setshowLoading(true);
        if (json_submit.indiceAnaliticoIQG_Id == 0)
            indiceiqg_api.postIndiceAnaliticoIQG(json_submit).then(result => handleReturnSubmit(result));
        else
            indiceiqg_api.putIndiceAnaliticoIQG(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', handleReturn);
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">

                <Row>
                    <Col md="12">
                        <Button color="default" onClick={Voltar}>
                            <i className="fas fa-chevron-left"></i>  Voltar
                        </Button>
                    </Col>
                </Row>
                <Card>
                    <CardHeader>
                        <h4 className="titleCard">Índice IQG</h4>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col lg="3" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Tipo de Índice</label>
                                        <Select
                                            name="tipoIndice"
                                            options={options_tipoIndice}
                                            getOptionLabel={o => o.label}
                                            getOptionValue={o => o.value}
                                            value={options_tipoIndice.filter(f => f.value == tipoIndice)}
                                            onChange={o => handleChangeTipoIndice(o.value)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            isDisabled={item || isDisable}
                                            ref={e => register(
                                                { name: "tipoIndice" },
                                                { required: !item })
                                            }
                                        />
                                        {errors.tipoIndice && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12" className={(tipoIndice == "Sintético" || tipoIndice == "Analítico") ? "" : "d-none"}>
                                    <FormGroup>
                                        <label className="form-control-label">Índice principal</label>
                                        <Select
                                            name="indicePrincipal"
                                            options={options_indicePrincipal}
                                            getOptionLabel={o => o.identificacao}
                                            getOptionValue={o => o.indiceIQG_Id}
                                            value={indicePrincipal}
                                            onChange={o => handleChangeIndicePrincipal(o)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register(
                                                { name: "indicePrincipal" },
                                                { required: (tipoIndice == "Sintético" || tipoIndice == "Analítico") })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {(tipoIndice == "Sintético" || tipoIndice == "Analítico") && errors.indicePrincipal && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12" className={tipoIndice == "Analítico" ? "" : "d-none"}>
                                    <FormGroup>
                                        <label className="form-control-label">Índice sintético</label>
                                        <Select
                                            name="indiceSintetico"
                                            options={options_indiceSintetico}
                                            getOptionLabel={o => o.identificacao}
                                            getOptionValue={o => o.indiceSinteticoIQG_Id}
                                            value={indiceSintetico}
                                            onChange={o => handleChangeIndiceSintetico(o)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register(
                                                { name: "indiceSintetico" },
                                                { required: tipoIndice == "Analítico" })
                                            }
                                            isDisabled={isDisable}
                                        />
                                        {tipoIndice == "Analítico" && errors.indiceSintetico && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Identificação</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="identificacao"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Fator peso</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="number"
                                            step={0.01}
                                            name="fatorPeso"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.fatorPeso && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            {!isDisable &&
                                <Row>
                                    <Col lg="12" md="12" sm="12" className="text-center">
                                        <Button color="success" type="submit">
                                            <i className="fas fa-save"></i>  Salvar
                                        </Button>
                                    </Col>
                                </Row>
                            }
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}

